import React from "react";
import { FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const FooterInfo = () => {
  return (
    <div className="footer-info">
      <h3>Terafac</h3>
      <p>
        Chandigarh, India
        <br />
        <strong>Phone:</strong> +91 8264445150
        <br />
        <strong>Email:</strong> info@terafac.com
        <br />
      </p>
      <div className="social-links mt-3">
        <a
          href="https://www.youtube.com/@terafactech"
          target="_blank"
          rel="noreferrer"
          className="youtube"
          aria-label="YouTube"
        >
          <FaYoutube />
        </a>
        <a
          href="https://www.instagram.com/terafactech/"
          target="_blank"
          rel="noreferrer"
          className="instagram"
          aria-label="Instagram"
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.linkedin.com/company/terafac-technologies-pvt-ltd/?viewAsMember=true"
          target="_blank"
          rel="noreferrer"
          className="linkedin"
          aria-label="LinkedIn"
        >
          <FaLinkedinIn />
        </a>
      </div>
    </div>
  );
};

export default FooterInfo;
